import { cn } from '@/lib/utils'
import { TriangleGradingMethod } from './types'
import { getTriangleLegendGradientCss, getTriangleLegendLabels } from './triangleUtils'
import { useIsDarkMode } from './useIsDarkMode'

export function TriangleGradingLegend({
  gradingMethod,
  className,
}: {
  gradingMethod: TriangleGradingMethod
  className?: string
}) {
  const isDarkMode = useIsDarkMode()
  const { title, startLabel, endLabel, ariaLabel } = getTriangleLegendLabels(gradingMethod)
  const gradient = getTriangleLegendGradientCss(gradingMethod, isDarkMode)

  return (
    <div className={cn('flex flex-col items-center gap-1.5', className)} role="img" aria-label={ariaLabel}>
      <span className="font-bold text-muted-foreground">{title}</span>
      {/* <div className="flex max-w-xl items-center gap-2 sm:gap-3"> */}
      <div className="flex w-full max-w-xl items-center gap-2 sm:gap-3">
        {/* <span className="w-14 shrink-0 text-right text-xs text-muted-foreground sm:w-16">{startLabel}</span> */}
        <span className="shrink-0 text-right text-xs text-muted-foreground">{startLabel}</span>
        <div
          className="h-3 min-w-[10rem] flex-1 rounded-full ring-1 ring-border"
          style={{ background: gradient }}
          aria-hidden
        />
        {/* <span className="w-14 shrink-0 text-xs text-muted-foreground sm:w-16">{endLabel}</span> */}
        <span className="shrink-0 text-xs text-muted-foreground">{endLabel}</span>
      </div>
    </div>
  )
}
